export default __webpack_public_path__ + "static/media/1-table-2-chair.5cfd77f5.png";